import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { Contact } from '../../interfaces/Contact';
import { ContactsActionCreators } from '../../store/contacts';
import { customersActionCreators } from '../../store/customers';
import { dataActionCreators } from '../../store/Data';
import { useMsal } from '@azure/msal-react';
import { TeamsState } from '../../store/TeamsState';
import { Button, Text } from '@fluentui/react-components';
import { Dismiss24Filled, Edit24Filled, Eye24Filled, Mail24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';
import { useCustomers } from '../Tools/ObjectLoader';

export const ContactQuickView = () => {
    const contactQuickView = useSelector<ApplicationState, Contact | null>((state: ApplicationState) => state.contactsState.contactQuickView);
    const { customers } = useCustomers();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    const styles = useQuickViewStyles();

    React.useEffect(() => {
        if (contactQuickView !== null && contactQuickView.contactCustomerRole === null && contactQuickView.contactCustomerRoleLoading === false && contactQuickView.contactid) {
            dispatch(ContactsActionCreators.requestContactsRoles(instance, teamsState, contactQuickView.contactid));
        }
    }, [contactQuickView]);

    if (contactQuickView) {
        const custList: JSX.Element[] = [];
        if (contactQuickView.contactCustomerRole && customers) {
            contactQuickView.contactCustomerRole.forEach((r) => {
                const cust = customers.find(x => x.customerid === r.customerid);
                if (cust && cust.displayName) {
                    custList.push(<div className={styles.titleAndOps}>
                        <Button appearance="transparent" style={{ padding: "0", border: "0", justifyContent: "start" }} onClick={() => dispatch(customersActionCreators.requestCustomerQuickView(cust))} >{cust.displayName}</Button>
                        <Text truncate>{r.relationShipTypeId ? t(r.relationShipTypeId) : "?"}</Text>
                    </div>);
                }
            });
        }

        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{"Contact : " + (contactQuickView.firstName + " " + contactQuickView.lastName)}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        <Button icon={<Edit24Filled />} shape="circular" title={t('Edit')} onClick={() => dispatch(ContactsActionCreators.requestContactEdition(contactQuickView))} />
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate>{contactQuickView.contactid}</Text>
                    </>
                }
                <h2>Name</h2>
                <Text truncate>{(contactQuickView.title ? (contactQuickView.title + " ") : "") + (contactQuickView.firstName ? (contactQuickView.firstName + " ") : "") + " " + (contactQuickView.lastName ? contactQuickView.lastName : "")}</Text>
                {contactQuickView.email &&
                    <>
                        <div className={styles.titleAndOps}>
                            <h2>Email</h2>
                            <Button
                                icon={<Mail24Filled />}
                                shape="circular"
                                title={t("SendAnEmail")}
                                onClick={() => {
                                    window.open("mailto:" + contactQuickView.email);
                                }}
                            />
                        </div>
                        <Text truncate>{contactQuickView.email}</Text>
                    </>
                }
                {contactQuickView.phone &&
                    <>
                        <h2>Phone</h2>
                        <Text truncate>{contactQuickView.phone}</Text>
                    </>
                }
                {contactQuickView.mobile &&
                    <>
                        <h2>Mobile</h2>
                        <Text truncate>{contactQuickView.mobile}</Text>
                    </>
                }
                {custList.length > 0 &&
                    <>
                        <h2>Roles</h2>
                        {custList.map(i => i)}
                    </>
                }

                {contactQuickView.linkedIn &&
                    <>
                        <div className={styles.titleAndOps}>
                            <h2>LinkedIn</h2>
                            <Button
                                icon={<Eye24Filled />}
                                shape="circular"
                                title={t("SendAnEmail")}
                                onClick={() => {
                                    if (contactQuickView.linkedIn) window.open(contactQuickView.linkedIn);
                                }}
                            />
                        </div>
                        <Text truncate>{contactQuickView.linkedIn}</Text>
                    </>
                }
                {contactQuickView.description && <>
                    <h2>Description</h2>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{contactQuickView.description}</pre>
                </>}
            </div>
        );
    }
    return null;
};